<template>
	<div class="edit-route-content">
		<el-dialog
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:before-close="close"
			top="3vh"
			width="80vw"
		>
			<span slot="title">
				<div class="title">
					<span>店铺位置采集:</span> {{ agent.agentName }}
					<span class="sap-address" v-if="agent.address">SAP地址：{{ agent.address }}</span>
				</div>
			</span>
			<div class="content">
				<div class="flex padding10a12">
					<div class="flex">
						<input
							type="text"
							id="tipinput"
							autocomplete="off"
							placeholder="店铺名或地址"
							v-model="agentName"
							class="width300"
						/>
						<img
							class="icon-s ml10"
							src="@/assets/images/search.png"
							@click="handleSearch"
							alt=""
						/>
					</div>
					<div class="ml15">
						<el-input v-model.trim="agentAddress" class="width500" size="small" disabled></el-input>
						<el-button type="primary" size="small" class="ml15" @click="handleSubmit">保存</el-button>
					</div>
				</div>
				<div id="editPointMap"></div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import initMap from "@/utils/amap.js"
export default {
	data() {
		return {
			dialogVisible: false,
			// 当前店铺信息
			agent: {
				agentName: ''
			},
			// 关键字
			agentName: "",
			// 地址
			agentAddress: "",
			//保存地图api，防止报错
			AMap: null,
			// 地图
			map: null,
			// 坐标marker
            marker: null,
			// 坐标反编译
			geocoder: null,
			// 搜索类
			placeSearch: null,
			// lng
			posLng: null,
			// lat
			posLat: null
		};
	},
	methods: {
		init(agent) {
			this.$nextTick(() => {
				console.log(agent)
				this.dialogVisible = true;
				agent.address != null ? agent.address = agent.address.replace(/\s*/g, "") : '';
				// 当前店铺信息
				this.agent = agent;
				this.agentName = "";
				this.agentAddress = "";
				this.marker = null;
				this.geocoder = null;
				this.placeSearch = null;
				this.posLng = null;
				this.posLat = null;
				this.initAMap();
			});
		},
		// 初始化地图
		initAMap() {
			initMap()
				.then(AMap => {
					this.map = new AMap.Map("editPointMap", {
						zoom: 11,
						zooms: [2, 22],
						center: [121.472644, 31.231706] // 初始化地图中心点位置
					});
					this.AMap = AMap;
					// 坐标逆编码
					var geocoder = new AMap.Geocoder({
						radius: 1000 //范围，默认：500
					});
					this.geocoder = geocoder;
					//输入提示
					var autoOptions = {
						input: "tipinput"
					};
					var auto = new AMap.AutoComplete(autoOptions);
					var placeSearch = new AMap.PlaceSearch({
						map: this.map
					});
					this.placeSearch = placeSearch;
                    // 绑定点击地图事件
                    this.map.on("click",this.handleClickMap);
					let that = this;
                    //构造地点查询类
					auto.on("select", function(e) {
						console.log(e);
						// 清除地图marker
						that.map.clearMap();
						// 设置marker
						that.setMarker(e.poi.location.lng, e.poi.location.lat);
						// 保存坐标并反编译坐标获取地址
						that.handleSavePointAndAddress(e.poi.location.lng, e.poi.location.lat);
						// 地图自适应
						that.map.setFitView();
					});
					// 有坐标时显示marker
					if(this.agent.posLat) {
						this.posLat = this.agent.posLat;
						this.posLng = this.agent.posLng;
						this.agentAddress = this.agent.posAddress;
						this.setMarker(this.agent.posLng, this.agent.posLat);
						this.map.setFitView();
					}
					// 没有坐标时位置直接查询
					else {
						if(this.agent.address) {
							this.agentName = this.agent.address;
						}
						else if(this.agent.posAddress) {
							this.agentName = this.agent.posAddress;
						}
						else {
							this.agentName = this.agent.agentName;
						}
						this.handleSearch();
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		// 关闭页面注销地图
		close() {
			this.map?.destroy();
			this.dialogVisible = false;
		},
        // 点击地图生成marker
        handleClickMap(e) {
			if(this.marker) {
				return
			}else {
				this.setMarker(e.lnglat.getLng(), e.lnglat.getLat());
				// 保存坐标并反编译坐标获取地址
				this.handleSavePointAndAddress(e.lnglat.getLng(), e.lnglat.getLat());
			}
        },
		// 生成marker
		setMarker(lng, lat) {
			let icon = new AMap.Icon({
				size: new AMap.Size(30, 42),
                image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
				imageSize: new AMap.Size(30, 42),
            });
			let marker = new AMap.Marker({
                icon: icon,
                position: [lng, lat],
				offset: new AMap.Pixel(-13, -30),
                draggable: true
            });
            marker.setMap(this.map);
			marker.on('dragend',this.handleDragend)
			this.marker = marker;
		},
		// marker拖拽结束事件
		handleDragend(e) {
			console.log(e)
			// 保存坐标并反编译坐标获取地址
			this.handleSavePointAndAddress(e.lnglat.lng, e.lnglat.lat);
		},
		// 保存坐标并反编译坐标获取地址
		handleSavePointAndAddress(lng, lat) {
			this.posLng = lng;
			this.posLat = lat;
			let that = this;
			// 坐标反编译获取地址
			this.geocoder.getAddress([lng, lat], function(status, result) {
				if (status === 'complete' && result.regeocode) {
					console.log(result)
					let street = result.regeocode.addressComponent;
					let streetAddress = `${street.province}${street.district}${street.township}${street.street}${street.streetNumber}`;
					let address = result.regeocode.formattedAddress;
					console.log(address)
					console.log(`${street.province}${street.district}${street.township}${street.street}${street.streetNumber}`)
					that.agentAddress = streetAddress;
				}else{
					log.error('根据经纬度查询地址失败')
				}
			});
		},
		// 点击搜索按钮关键字检索
		handleSearch() {
			console.log(`搜索名称:${this.agentName}`)
			if(this.agentName) {
				let that = this;
				that.placeSearch.search(that.agentName, function (status, result) {
					// 查询成功时，result即对应匹配的POI信息
					console.log(result)
					if(result.info == "OK" && result?.poiList?.pois) {
						var pois = result.poiList.pois;
						// 清除地图marker
						that.map.clearMap();
						// 设置marker
						that.setMarker(pois[0]['location']['lng'], pois[0]['location']['lat']);
						// 保存坐标并反编译坐标获取地址
						that.handleSavePointAndAddress(pois[0]['location']['lng'], pois[0]['location']['lat']);
						// 地图自适应
						that.map.setFitView();
					}
				})
			}
		},
		// 保存采集点
		handleSubmit() {
			if(this.marker) {
				this.$confirm("确定保存采集的坐标？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				})
					.then(() => {
						this.$request
							.post("routeMapAddPoint", true, {
								agentId: this.agent.agentId,
								posLng: this.posLng,
								posLat: this.posLat,
								posAddress: this.agentAddress
							})
							.then(res => {
								this.$message.success('保存成功');
								this.dialogVisible = false;
								if(this.agent.type == 'notposition') {
									this.$emit('setList',this.agent);
								}else {
									this.$emit('getRouteInfo');
								}
							});
					})
					.catch(() => {

					});
			}
		},
	}
};
</script>
<style lang="scss" scoped>
.title {
	font-size: 14px;
	span{
		 font-weight: bold;
	}
}
#editPointMap {
	height: calc(100vh - 8vh - 102px);
}

.edit-route-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}
.edit-route-content /deep/ .el-table .cell,
.edit-route-content /deep/ .el-table .el-table__cell,
.edit-route-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px;
}
.edit-route-content /deep/ .el-table .cell,
.edit-route-content /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding-left: 0;
}
.icon-s {
	width: 32p;
	height: 32px;
	cursor: pointer;
}
.cursor-pointer {
	cursor: pointer;
}
::v-deep .amap-marker-label {
	border: none;
	background: rgba(0, 0, 0, 0.6);
	color: #fff;
	padding: 8px;
	border-radius: 5px;
}
::v-deep .amap-sug-result {
	z-index: 99999;
}

#tipinput{
	background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 13px;
	outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

.padding10a12{
	padding: 10px 12px;
}

.width300{
	width: 300px;
}

.width500{
	width: 440px;
}

.sap-address {
	font-weight: normal !important;
    margin-left: 20px;
}
</style>
<style>
.amap-sug-result {
	z-index: 99999;
}
</style>
